// global events - which can be published and subscribed by anyone
// ideal usage in a ReactJS component
//     - subscribe in componentDidMount
//     - unsubscribe in componentWillUnmount

const _subscriptions = {};

function subscribe(topic, callback) {
  _subscriptions[topic] = _subscriptions[topic] || [];
  _subscriptions[topic].push(callback);
  return () => unsubscribe(topic, callback);
}

function unsubscribe(topic, callback) {
  if(_subscriptions[topic]) {
    _subscriptions[topic] = _subscriptions[topic].filter(c => c !== callback);
  }
}

function publish(topic, data) {
  if(!_subscriptions[topic] || !_subscriptions[topic].length)
    return false;

  _subscriptions[topic].forEach(s => {
    try {
      s(data);
    } catch {
      //skip
    }
  });
}

export {
  subscribe, unsubscribe, publish
};
